<template>
  <BaseCard
    :caption-visible="false"
    :footer-visible="false"
  >
    <template #title>
      <span class="h3 font-weight-bold mb-0 text-uppercase">stock</span>
    </template>
    <StockTable />
  </BaseCard>
</template>

<script>
import BaseCard from '@/components/ui/card/BaseCard.vue'
import StockTable from '@/components/stock/table/StockTable.vue'

export default {
  components: {
    StockTable,
    BaseCard,
  },
}
</script>
